// PATH IN YOUR PROJECT: src/components/Header/NavTabs/NavTabs.js
import React from "react"
import { NavLink } from "react-router-dom"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import { ICONS } from "../../constants/icons"

/**
 * NavTabs
 * ------------------------------------------------------------------
 * Primary navigation for the header's left zone. Renders as a
 * horizontal list of icon + label tabs. Active state is derived
 * from the current route via react-router's NavLink, so it stays
 * correct on refresh/deep-link — no manual "activeKey" bookkeeping
 * needed.
 *
 * Pass a custom `items` array to reuse this component anywhere else
 * a tab-style nav is needed; defaults to the app's primary nav.
 */
export const getDefaultNavItems = currentUser =>
  DEFAULT_NAV_ITEMS.map(item =>
    item.key === "my-profile" && currentUser?.id
      ? { ...item, to: `/profile/${currentUser.id}` }
      : item,
  )

export const DEFAULT_NAV_ITEMS = [
  {
    key: "dashboard",
    label: "Dashboard",
    icon: ICONS.navDashboard,
    to: "/dashboard",
  },
  {
    key: "projects",
    label: "Projects",
    icon: ICONS.navProjects,
    to: "/projects",
  },
  {
    key: "calls-for-artist",
    label: "Inboxes & Calls for Artist",
    icon: ICONS.navCallsForArtist,
    to: "/calls-for-artist",
  },
  {
    key: "collaborators",
    label: "Collaborators",
    icon: ICONS.navCollaborators,
    to: "/collaborators",
  },
  { key: "invites", label: "Invites", icon: ICONS.navInvites, to: "/invites" },
  {
    key: "city-hub",
    label: "City Hub",
    icon: ICONS.navCityHub,
    to: "/city-hub",
  },
  {
    key: "rewards",
    label: "Treasure & XP",
    icon: ICONS.navRewards,
    to: "/rewards",
  },
  {
    key: "my-profile",
    label: "My Profile",
    icon: ICONS.navProfile,
    to: "/profile",
  },
]

const NavTabs = ({ items }) => {
  const currentUser = useSelector(state => state.auth.currentUser)
  const navItems =
    items && items.length ? items : getDefaultNavItems(currentUser)

  return (
    <nav className="nav-tabs-group" aria-label="Primary">
      <ul className="nav-tabs-group__list">
        {navItems.map(item => (
          <li key={item.key} className="nav-tabs-group__item">
            <NavLink
              to={item.to}
              className={({ isActive }) =>
                `nav-tab${isActive ? " nav-tab--active" : ""}`
              }
            >
              <img src={item.icon} alt="" className="nav-tab__icon" />
              <span className="nav-tab__label">{item.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}

NavTabs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      to: PropTypes.string.isRequired,
    }),
  ),
}

export default NavTabs
